// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"529":"48157145","837":"dcb80f82","4255":"260a5f25"}[chunkId] + ".chunk.css";
};